import React, { useEffect, useState, useCallback } from 'react';
// import { Row, Col, Upload, Button, message, Select, DatePicker } from "antd";
// import { useForm } from "react-hook-form";
// import { UploadOutlined } from "@ant-design/icons";
import PaymentForm from '../../form/subscription/PaymentForm';
import { getUser } from '../../api';
import useApplicationSession from '../../session/UserSession';
import usePaymentSession from '../../session/PaymentSession';
import { PAYMENT } from '../../api/EndPoints';

const Payment = () => {
    const [userdata, setUserdata] = useState(null);
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const { payments } = response.data;
                    setUserdata(payments);
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    usePaymentSession(PAYMENT);

    return (
        <div test_id="subscription-payment" className="subscriptionContentContainer">
            <PaymentForm value={userdata} token={token} />
        </div>
    );
};

export default Payment;
